import React, { useState } from "react";
import "./index.css";

export const InputBox = ({ addNote }) => {
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  return (
    <div className="input-box-view">
      <form
        onSubmit={(e) => {
          addNote({ header: header, body: body });
          setHeader("");
          setBody("");
          e.preventDefault();
        }}
      >
        <input
          className="input-box-header"
          type="text"
          onChange={(e) => setHeader(e.target.value)}
          value={header}
          placeholder="Title"
          required
        />
        <textarea
          className="input-box-body"
          onChange={(e) => setBody(e.target.value)}
          placeholder="Take a note..."
          value={body}
          required
        />
        <button type="submit" className="input-box-button">
          <svg
          className='input-box-button-icon'
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 0 24 24"
            width="24px"
            fill="#000000"
          >
            <path d="M0 0h24v24H0V0z" fill="none" />
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
          </svg>
        </button>
      </form>
    </div>
  );
};
